import { useState } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import wait from 'src/utils/wait';
import useAuth from 'src/hooks/useAuth';

import {
  styled,
  Grid,
  
  Box,
  Zoom,
  Typography,
  
  Button
} from '@mui/material';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import { useSnackbar } from 'notistack';
import CloudUploadTwoToneIcon from '@mui/icons-material/CloudUploadTwoTone';
import CreateCustomerDialog from '../create-customer-dialog';

const Input = styled('input')({
  display: 'none'
});

const AvatarWrapper = styled(Box)(
  ({ theme }) => `

    position: relative;

    .MuiAvatar-root {
      width: ${theme.spacing(16)};
      height: ${theme.spacing(16)};
    }
`
);

const ButtonUploadWrapper = styled(Box)(
  ({ theme }) => `
    position: absolute;
    width: ${theme.spacing(6)};
    height: ${theme.spacing(6)};
    bottom: -${theme.spacing(2)};
    right: -${theme.spacing(2)};

    .MuiIconButton-root {
      border-radius: 100%;
      background: ${theme.colors.primary.main};
      color: ${theme.palette.primary.contrastText};
      box-shadow: ${theme.colors.shadows.primary};
      width: ${theme.spacing(6)};
      height: ${theme.spacing(6)};
      padding: 0;
  
      &:hover {
        background: ${theme.colors.primary.dark};
      }
    }
`
);

type PageHeaderProps = {
  isCreateCustomerDialogOpen: boolean;
  onOpenCreateCustomerDialog: () => void;
  onCloseCreateCustomerDialog: () => void;
};

function PageHeader({
  isCreateCustomerDialogOpen,
  onOpenCreateCustomerDialog,
  onCloseCreateCustomerDialog
}: PageHeaderProps) {
  const { t }: { t: any } = useTranslation();
  const [open, setOpen] = useState(false);
  // const [isCreateCustomerDialogOpen, setIsCreateCustomerDialogOpen] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const handleOpenCreateCustomerDialog = () => {
    // setIsCreateCustomerDialogOpen(true);
    onOpenCreateCustomerDialog()
  };

  const handleCreateCustomerSuccess = () => {
    enqueueSnackbar(t('The Discount was created successfully'), {
      variant: 'success',
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right'
      },
      TransitionComponent: Zoom
    });

    setOpen(false);
  };

  return (
    <>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <Typography variant="h3" component="h3" gutterBottom>
            {t('Discount Management')}
          </Typography>
          <Typography variant="subtitle2">
            {t(
              'All aspects related to the app Discount can be managed from this page'
            )}
          </Typography>
        </Grid>
        <Grid item>
          <Button
            sx={{
              mt: { xs: 2, sm: 0 }
            }}
            variant="contained"
            startIcon={<AddTwoToneIcon fontSize="small" />}
            onClick={handleOpenCreateCustomerDialog}
          >
            {t('Create Discount')}
          </Button>
        </Grid>
      </Grid>
      <CreateCustomerDialog
        open={isCreateCustomerDialogOpen}
        onClose={() => {
          onCloseCreateCustomerDialog()
          // setIsCreateCustomerDialogOpen(false)
        }}
        discountId=''
        flag={0}
      />
      
    </>
  );
}

export default PageHeader;
